import { html } from "htm/preact";
import { hydrate } from "preact";
import NavButtonMobile from "../components/NavButtonMobile.js";
const el = document.getElementById("nav-button-mobile-island");
if (el) {
  
  hydrate(html`<${NavButtonMobile} />`, el);
}